import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, message } from 'antd';
import dayjs from 'dayjs';
import { useI18n } from '../i18n';
import InquiryHeaderFields from '../components/InquiryHeaderFields';

const buildState = (inquiry) => ({
  createdBy: inquiry?.createdBy || '',
  clientId: inquiry?.clientId ?? null,
  deliveryAddress: inquiry?.deliveryAddress || '',
  priority: inquiry?.priority || 'Medium',
  neededBefore: inquiry?.neededBefore ? dayjs(inquiry.neededBefore) : null,
  requestedDeliveryDate: inquiry?.requestedDeliveryDate ? dayjs(inquiry.requestedDeliveryDate) : null,
});

export default function InquiryHeaderEditModal({
  open,
  inquiry,
  leads = [],
  users = [],
  onSave,
  onCancel,
}) {
  const { t } = useI18n();
  const [form, setForm] = useState(() => buildState(inquiry));
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setForm(buildState(inquiry));
      setErrors({});
    }
  }, [open, inquiry]);

  const updateField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleOk = () => {
    const nextErrors = {};
    if (!form.createdBy) nextErrors.createdBy = t('Created by is required');
    if (!form.clientId) nextErrors.clientId = t('Client name is required');
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      message.warning(t('Please fill in the required fields'));
      return;
    }
    setErrors({});

    const lead = leads.find((l) => l.id === form.clientId);
    onSave?.({
      createdBy: form.createdBy,
      clientId: form.clientId,
      client: lead?.name || inquiry?.client || '',
      deliveryAddress: form.deliveryAddress,
      priority: form.priority,
      neededBefore: form.neededBefore ? form.neededBefore.format('YYYY-MM-DD') : null,
      requestedDeliveryDate: form.requestedDeliveryDate ? form.requestedDeliveryDate.format('YYYY-MM-DD') : null,
    });
  };

  return (
    <Modal
      title={t('Edit Inquiry')}
      open={open}
      onCancel={onCancel}
      width={720}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onCancel}>{t('Cancel')}</Button>,
        <Button key="save" type="primary" onClick={handleOk}>{t('Save')}</Button>,
      ]}
    >
      <Form layout="vertical">
        <InquiryHeaderFields
          value={form}
          onChange={updateField}
          leads={leads}
          users={users}
          errors={errors}
        />
      </Form>
    </Modal>
  );
}
